import { CDS_ROUTE_NAME, DEA_ROUTE_NAME, MEDICAL_LICENSE_ROUTE_NAME } from '~/features/routeNames';
import { getData } from '~/utils/service';
import { GetEvent } from './events';
import { CombinedLicenseResponse, Scope } from './types';
import {
  cdsApiToCombinedLicenses,
  deaApiToCombinedLicenses,
  medicalLicenseApiToCombinedLicense,
} from './utils';

const PAGE_SIZE = 5;
const PAGE = 1;

export const LICENSE_API_CALLS = {
  get: async ({ input }: { input: Scope }): Promise<CombinedLicenseResponse> => {
    const { providerId } = input.event as GetEvent;

    const [cdsResponse, deaResponse, medicalLicenseResponse] = (await Promise.all([
      getData(CDS_ROUTE_NAME, {
        params: { providerId, active: true, inactive: true },
        sort: { page: PAGE, pageSize: PAGE_SIZE, sortBy: 'id' },
        transformResponse: cdsApiToCombinedLicenses,
      }),
      getData(DEA_ROUTE_NAME, {
        params: { providerId, active: true, inactive: true },
        sort: { page: PAGE, pageSize: PAGE_SIZE, sortBy: 'id' },
        transformResponse: deaApiToCombinedLicenses,
      }),
      getData(MEDICAL_LICENSE_ROUTE_NAME, {
        params: { providerId },
        transformResponse: medicalLicenseApiToCombinedLicense,
      }),
    ])) as [CombinedLicenseResponse, CombinedLicenseResponse, CombinedLicenseResponse];

    const allLicenses = [...cdsResponse.data, ...deaResponse.data, ...medicalLicenseResponse.data];

    return {
      data: allLicenses,
      page: PAGE,
      pageSize: PAGE_SIZE,
      total: allLicenses.length,
    };
  },
};
